export default __webpack_public_path__ + "static/2-d595d030104b59d0f50675b1673c94f8.png";